import React from 'react'

import { LazyBoundary } from '../ChunkErrorBoundary.jsx'

const ISReactDraftEditorContent = React.lazy(
  () => import('./ISReactDraftEditorContent.jsx'),
)

const ISReactDraftEditor = props => (
  <LazyBoundary>
    <ISReactDraftEditorContent {...props} />
  </LazyBoundary>
)

export default ISReactDraftEditor
